// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "service-xbjvE";
var _5 = "wrapper-2u5TA";
var _6 = "title-f88xF";
var _7 = "segmentTabs__inner-STfVg";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "service", _5 as "wrapper", _6 as "title", _7 as "segmentTabs__inner" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "service": _4, "wrapper": _5, "title": _6, "segmentTabs__inner": _7 }
